<mat-calendar #calendar
  [startAt]="currentDate$ | async"
  [selected]="currentDate$ | async"
  (selectedChange)="setDate($event)"
  (monthSelected)="setMonth($event)"
></mat-calendar>
